// @flow

import * as React from 'react';

import clsx from 'clsx';

import { useTranslator } from '@gandi/translate';
import { Interactive, Svg, type InteractiveProps } from '@gandi/ui';

import styles from './Hamburger.scss';

export type Props = {
  className?: string,
  ...
} & InteractiveProps;

function Hamburger({ className, ...extraProps }: Props): React.Node {
  const { __ } = useTranslator();

  return (
    // $FlowFixMe[cannot-spread-inexact]
    <Interactive
      type="button"
      title={__('Open Navigation')}
      flex
      flexShrink0
      flexJustifyCenter
      flexAlignItemsCenter
      className={clsx(styles.root, className)}
      {...extraProps}
    >
      <Svg name="hamburger" theme="neutral-strong" />
    </Interactive>
  );
}

export default Hamburger;
